import en from './en';

const hy = { ...en };

export default hy;
